import Assignment from "../../model/Assignment";
import {ASSIGNMENT, UPDATE_ASSIGNMENT} from "../../actions";

function getNewAssignment() {
    return new Assignment("", "", "", "", "");
}

export default function (state = getNewAssignment(), action) {
    switch (action.type) {
        case UPDATE_ASSIGNMENT:
            return Object.assign(getNewAssignment(), action.payload);
        case ASSIGNMENT:
            return Assignment.fromResponse(action.payload.data);
        default:
            return state;
    }
}
